import React, { useEffect, useRef } from "react";
import { FaArrowLeft, FaQrcode, FaRegCommentDots, FaDownload, FaPrint, FaTimesCircle, FaCheckCircle, FaThermometerHalf, FaBox, FaUser } from "react-icons/fa";
import { useState } from "react";
import gate from "../../../assets/svg/gateout.svg";
import clck from "../../../assets/svg/clock.svg";
import len from "../../../assets/svg/lentra.svg";
import profile from "../../../assets/svg/profile.svg";
import business from "../../../assets/svg/business.svg";
import production from "../../../assets/svg/production.svg";
import qr from "../../../assets/svg/QR 2.svg";
import mail from "../../../assets/svg/mail.svg";
import mobile from "../../../assets/svg/mobile.svg";
import limited from "../../../assets/svg/limited.svg";
import location from "../../../assets/svg/location.svg";
import proofphn from "../../../assets/svg/proofphn.svg";
import vechiles from "../../../assets/svg/vechiles.svg";
import itemname from "../../../assets/svg/itemname.svg";
import Description from "../../../assets/svg/Description.svg";
import Quantity from "../../../assets/svg/Quantity.svg";
import download from "../../../assets/svg/download.svg";
import print from "../../../assets/svg/print.svg";
import aadhar from "../../../assets/svg/aadhaar.svg";
import name from "../../../assets/svg/name.svg";
import mnumber from "../../../assets/svg/mnumber.svg";
import relation from "../../../assets/svg/relation.svg";
import proof from "../../../assets/svg/Proof.svg";
import age from "../../../assets/svg/age.svg";
import abilash from "../../../assets/svg/abilash.svg";
import saran from "../../../assets/svg/saran.svg";
import santhosh from "../../../assets/svg/santhosh.svg";
import meenaktchi from "../../../assets/svg/meenaktchi.svg";
import direct from "../../../assets/svg/direct.svg";
import nandhu from "../../../assets/svg/nandhu.svg";
import druken from "../../../assets/svg/druken.svg";
import temp from "../../../assets/svg/temp.svg";
import add from "../../../assets/svg/add.svg";
import visit_active from "../../../assets/svg/visitor-detail-active.svg";
import visit_inactive from "../../../assets/svg/visitor-detail-inactive.svg";
import history_active from "../../../assets/svg/history-active.svg";
import history_inactive from "../../../assets/svg/history-inactive.svg";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import TopBar from "../../topbar/TopBar";
import { checkListFailsUpdateApi, gateInApprovedCheckListApi, gateOutApi, getHistoryListApi, getResponsiblePersonApi, getVisitorDetailsApi, queueStatusUpdateApi, updateExpiryDateApi } from "../visitor-api";
import { ReactComponent as CheckTrue } from "../../../assets/svg/check-true.svg";
import "./visitor-view.css";
import { QRCodeSVG } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import gatedetail from "../../../assets/svg/gate-details.svg";
import visitor_entry from "../../../assets/svg/visitor-entry.svg";
import visitor_gate_in from "../../../assets/svg/gatein.svg";
import acknowledged from "../../../assets/svg/acknowledged.svg";
import gate_out from "../../../assets/svg/gateout.svg";
import queue_entry from "../../../assets/svg/queue-entry.svg";
import expiry_date from "../../../assets/svg/date.svg";
import history_approve from "../../../assets/svg/history-approve.svg";
import history_reject from "../../../assets/svg/history-reject.svg";
import CheckListFailedAdminModal from "../../modal-dialog/checklist-failed-admin-modal";
import GateOutModal from "../../modal-dialog/gate-out-modal";
import DOMPurify from "dompurify";
import QueueApproveModal from "../../modal-dialog/queue-approve-modal";
import UpdateScheduleStatusModal from "../../modal-dialog/update-schedule-status-modal";
import { useLocation, useNavigate } from "react-router-dom";
import date from "../../../assets/svg/date.svg";
import GenerateQRModal from "../../modal-dialog/generate-qr-modal";
import customerIcon from "../../../assets/png/customer-icon.png";
import AcknowledgementModal from "../../modal-dialog/acknowledgement-modal";
import moment from "moment";
import clock from "../../../assets/svg/clock.svg";

function VisitorView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const getSafeValue = (value) => {
    return value === "" || value === null || value === undefined ? "-" : value;
  };

  const [selectedVisitHistory, setSelectedVisitHistory] = useState("Visitor");
  const [activeTab, setActiveTab] = useState("items");
  const [showQueueApproveModal, setShowQueueApproveModal] = useState(false);
  const [showUpdateScheduleStatusModal, setShowUpdateScheduleStatusModal] = useState(false);
  const [showGateOutDetails, setShowGateOutDetails] = useState(false);
  const [showGenerateQRCode, setShowGenerateQRCode] = useState(false);
  const [showAcknowledgementModal, setAcknowledgementModal] = useState(false);
  const [loginId, setLoginId] = useState(null);
  const [visitorDetails, setVisitorDetails] = useState({});
  const [visitorHistory, setVisitorHistory] = useState([]);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [responsiblePerson, setResponsiblePerson] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [expiryDate, setExpiryDate] = useState("");
  useEffect(() => {
    getVisitorDetails();
    getHistoryList();
  }, []);
  useEffect(() => {
    if (id) {
      console.log("New visitor ID:", id);
      getVisitorDetails();
      getHistoryList();
    }
  }, [id]);

  const getVisitorDetails = async () => {
    try {
      const response = await getVisitorDetailsApi(id);
      if (response.status === true) {
        setVisitorDetails(response.visitor ?? {});
        setLoginId(response.loginId.toString());
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getHistoryList = async () => {
    try {
      const response = await getHistoryListApi(id, "visitor");
      if (response.status === true) {
        setVisitorHistory(response.history ?? []);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const printRef = useRef(null);
  /*  const downloadQR = () => {
     const canvas = printRef.current.querySelector("canvas");
     const url = canvas.toDataURL("image/png");
     const link = document.createElement("a");
     link.href = url;
     link.download = "qrcode.png";
     link.click();
   }; */

  const downloadQR = () => {
    const svgElement = printRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const DOMURL = window.URL || window.webkitURL || window;
    const url = DOMURL.createObjectURL(svgBlob);

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const size = 800;
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext("2d");

      // Draw transparent background (optional, it's already transparent by default)
      ctx.clearRect(0, 0, size, size);

      ctx.drawImage(image, 0, 0, size, size);

      // ✅ Convert to PNG and download
      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `QR_${visitorDetails.transaction_id}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      DOMURL.revokeObjectURL(url);
    };

    image.src = url;
  };

  /* const handlePrint = useReactToPrint({
    content: () => printRef.current, // Must return a DOM element
  }); */
  const handlePrint = () => {
    if (printRef.current) {
      // Create a hidden iframe to print from (doesn't open a new tab)
      const printIframe = document.createElement("iframe");
      printIframe.style.position = "absolute";
      printIframe.style.width = "0";
      printIframe.style.height = "0";
      printIframe.style.border = "none";
      printIframe.style.left = "-9999px";
      document.body.appendChild(printIframe);

      const iframeDoc = printIframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(`
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              margin: 0;
            }
          </style>
        </head>
        <body>
          ${printRef.current.innerHTML}
        </body>
      </html>
    `);
      iframeDoc.close();

      // Wait for iframe to load, then print
      printIframe.contentWindow.focus();
      printIframe.contentWindow.print();

      // Remove iframe after printing
      setTimeout(() => {
        document.body.removeChild(printIframe);
      }, 1000);
    }
  };

  const HistoryIcon = ({ status }) => {
    let imageIcon;
    switch (status) {
      case "Visitor entry":
        imageIcon = <img src={visitor_entry} alt="" />;
        break;
      case "Gate-In":
        imageIcon = <img src={visitor_gate_in} alt="" />;
        break;
      case "Acknowledgement":
        imageIcon = <img src={acknowledged} alt="" />;
        break;

      case "Gate out":
        imageIcon = <img src={gate_out} alt="" />;
        break;
      case "Queue entry":
        imageIcon = <img src={queue_entry} alt="" />;
        break;

      case "Expiry date update":
        imageIcon = <img src={expiry_date} alt="" />;
        break;

      case "Checklist approved":
      case "Checklist failed & approved":
      case "Queue approved & Gate-In":
      case "Queue approved":
      case "Schedule Approved":
      case "Schedule updated to":
        imageIcon = <img src={history_approve} alt="" />;
        break;

      case "Checklist rejected":
      case "Queue rejected":
      case "Checklist failed":
      case "Schedule rejected":
        imageIcon = <img src={history_reject} alt="" />;
        break;

      default:
        imageIcon = "";
    }

    return imageIcon;
  };
  useEffect(() => {
    if (selectedStatus !== "") {
      setChecklistFailedAdminModal(true);
    }
  }, [selectedStatus]);

  const onApprovedCheckList = async () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("approve");
  };
  const onRejectedCheckList = () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("reject");
  };
  const checkListFailsUpdate = async (status) => {
    try {
      const response = await checkListFailsUpdateApi(id, status, "visitor");
      if (response?.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        getVisitorDetails();
        getHistoryList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const gateInApprovedCheckList = async () => {
    try {
      const response = await gateInApprovedCheckListApi(id, "visitor");
      if (response?.data.status === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
        getVisitorDetails();
        getHistoryList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const onProceedGateOut = async (itemList, selectedCustomer, attachments, remarks) => {
    setShowGateOutDetails(false);
    gateOut(itemList);
  };

  const gateOut = async (itemList) => {
    try {
      const response = await gateOutApi({
        visitor_id: id,
        items: itemList.map((item) => ({
          item_name: DOMPurify.sanitize(item.item_name),
          quantity: DOMPurify.sanitize(item.quantity),
          description: DOMPurify.sanitize(item.description),
        })),
      });

      if (response?.data.status === true) {
        console.log(response);
        getVisitorDetails();
        getHistoryList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const onApproveQueue = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getVisitorDetails();
    getHistoryList();
  };
  const onApproveQueueAndGateIn = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getVisitorDetails();
    getHistoryList();
  };
  const onScheduleStatusSuccess = async (response) => {
    setShowUpdateScheduleStatusModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getVisitorDetails();
    getHistoryList();
  };

  const queueStatusUpdate = async () => {
    const payload = {
      id: visitorDetails.id,
      status: "",
      meeting_person: 0,
      checklists: [],
      queue_status: "Rejected", // Approved, Rejected
      validate_check_list: true, // true, fasle
      check_list_status: "", //pending, approve
      type: "visitor", // pending, approved, rejected
      items: [],
    };
    try {
      const response = await queueStatusUpdateApi(payload);
      if (response.statusCode === 400) {
      } else {
        if (response.data.status === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          getVisitorDetails();
          getHistoryList();
        } else {
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const updateExpiry = async (date) => {
    try {
      const response = await updateExpiryDateApi(id, { date: date });

      if (response?.data.status === true) {
        console.log(response);
        getVisitorDetails();
        getHistoryList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const calculateDays = (endDate) => {
    const date1 = moment();
    const date2 = moment(endDate, "DD-MM-YYYY");
    console.log("date1..", date1);
    console.log("date2..", date2);
    // const diffInDays = date2.diff(date1, 'days');
    //     const date1 = moment("2025-04-01"); // Convert to moment object
    // const date2 = moment("2025-04-19"); // Convert to moment object

    const diffInDays = date2.diff(date1, "days") + 1;
    return diffInDays;
  };
  const onAcknowledgeSuccess = async (response) => {
    setAcknowledgementModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getVisitorDetails();
    getHistoryList();
  };
  return (
    <Container fluid className="main-container">
      {showQueueApproveModal && (
        <QueueApproveModal
          fromModule={"Visitor"}
          visitorDetails={visitorDetails}
          onApproveQueue={onApproveQueue}
          onApproveQueueAndGateIn={onApproveQueueAndGateIn}
          onCancel={() => {
            setShowQueueApproveModal(false);
          }}
        />
      )}
      {showUpdateScheduleStatusModal && (
        <UpdateScheduleStatusModal
          visitorId={visitorDetails.id}
          onSuccess={onScheduleStatusSuccess}
          onCancel={() => {
            setShowUpdateScheduleStatusModal(false);
          }}
        />
      )}
      {showChecklistFailedAdminModal && (
        <CheckListFailedAdminModal
          moduleId={visitorDetails.id}
          moduleName={"Visitor"}
          checkList={visitorDetails.checklist ?? []}
          visitorName={visitorDetails.visitor_name}
          organization={visitorDetails.organization}
          visitorPicture={visitorDetails.profilephoto ?? ""}
          isSaveEnable={false}
          isApprovedEnable={selectedStatus === "Approve" ? true : false}
          onApproved={onApprovedCheckList}
          isRejectedEnable={selectedStatus === "Reject" ? true : false}
          onRejected={onRejectedCheckList}
          onCancel={() => {
            setChecklistFailedAdminModal(false);
            setSelectedStatus("");
          }}
        />
      )}
      {showGateOutDetails && (
        <GateOutModal
          moduleName={"Visitor"}
          visitorDetails={visitorDetails}
          onProceed={onProceedGateOut}
          onCancel={() => {
            setShowGateOutDetails(false);
          }}
        />
      )}
      {showGenerateQRCode && (
        <GenerateQRModal
          moduleName={"Visitor"}
          visitorDetails={visitorDetails}
          onCancel={() => {
            setShowGenerateQRCode(false);
          }}
        />
      )}
      {showAcknowledgementModal && (
        <AcknowledgementModal
          moduleName={"Visitor"}
          visitorDetails={visitorDetails}
          onSuccess={onAcknowledgeSuccess}
          onCancel={() => {
            setAcknowledgementModal(false);
          }}
        />
      )}

      <div style={{ width: "100vw" }}>
        <TopBar currentName="visitor" />
        <div style={{ display: "flex", flexDirection: "column", padding: "10px 20px", backgroundColor: "#fff", borderRadius: "8px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Left Section: Back Button, Profile Icon, Name, Company */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaArrowLeft
                onClick={() => {
                  navigate(-1);
                }}
                style={{ fontSize: "18px", marginRight: "15px", cursor: "pointer" }}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ width: "35px", height: "35px", backgroundColor: "#2d3748", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: "bold", marginRight: "10px" }}>
                  {visitorDetails.profilephoto != null && visitorDetails.profilephoto !== "" && (
                    <img
                      src={visitorDetails.profilephoto}
                      alt="Emilia Jackson"
                      style={{
                        borderRadius: "50%",
                        width: "35px",
                        height: "35px",
                      }}
                    />
                  )}
                  {(visitorDetails.profilephoto == null || visitorDetails.profilephoto === "") && visitorDetails.visitor_name?.trim().charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className="card-title">{getSafeValue(visitorDetails.visitor_name)}</div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={len} alt="" /> <div className="field-title px-2 pt-1">{getSafeValue(visitorDetails.organization)}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section: QR Code & Acknowledgement Buttons */}
            <div style={{ display: "flex", gap: "10px" }}>
              {visitorDetails.schedule_update === true && (
                <div
                  className="schedule-status-btn style-justify-center"
                  onClick={() => {
                    setShowUpdateScheduleStatusModal(true);
                  }}
                >
                  Update scheduled status
                </div>
              )}
              {visitorDetails.queue_update === true && (
                <div className="style-justify-center">
                  <div
                    className="checklist-reject-btn style-justify-center"
                    onClick={() => {
                      queueStatusUpdate();
                    }}
                  >
                    Reject
                  </div>
                  <div
                    className="approve-btn style-justify-center"
                    onClick={() => {
                      setShowQueueApproveModal(true);
                    }}
                  >
                    Approve
                  </div>
                </div>
              )}
              {loginId !== null && visitorDetails.responsible_person === loginId && visitorDetails.checklist_approve === true && (
                /* visitorDetails.check_list_status==="pending" && visitorDetails.is_check_passed===false && */ <div className="style-justify-center">
                  <div
                    className="checklist-reject-btn style-justify-center"
                    onClick={() => {
                      setSelectedStatus("Reject");
                    }}
                  >
                    Reject
                  </div>
                  <div
                    className="approve-btn style-justify-center"
                    onClick={() => {
                      setSelectedStatus("Approve");
                    }}
                  >
                    Approve
                  </div>
                </div>
              )}
              {/* {visitorDetails.in_time !=null 
&& (
  (visitorDetails.meeting_type==='Direct' && (visitorDetails.is_check_passed=== true || (visitorDetails.is_check_passed=== false && visitorDetails.check_list_status=== 'approve'))) 
  || (visitorDetails.meeting_type==='Schedule' && visitorDetails.schedule_status==='Approved')
  || (visitorDetails.entry_type==='usingQr' && visitorDetails.queue_status==='Approved'))  &&  ( */}{" "}
              {visitorDetails.gate_in === true && (
                <div style={{ border: "dashed 2px #2C8C53", padding: "2px", borderRadius: "100px" }}>
                  <button
                    style={{
                      border: "none",
                      backgroundColor: "#2C8C53",
                      color: "#fff",
                      padding: "6px 16px",
                      borderRadius: "20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                      zIndex: 2,
                    }}
                    onClick={() => gateInApprovedCheckList()}
                  >
                    <img src={gate} alt="" /> <span className="px-2">Gate In</span>
                  </button>
                </div>
              )}
              {/* )} */}
              {visitorDetails.in_time != null && visitorDetails.out_time == null && visitorDetails.schedule_status !== "Reject" && (
                <button
                  onClick={() => {
                    setShowGenerateQRCode(true);
                  }}
                  style={{ display: "flex", alignItems: "center", backgroundColor: "#f5f5f5", border: "1px solid #ddd", padding: "8px 12px", borderRadius: "12px", cursor: "pointer", fontSize: "13.5px", fontWeight: "500" }}
                >
                  <FaQrcode style={{ marginRight: "5px" }} /> Generate QR
                </button>
              )}
              {visitorDetails.in_time != null && visitorDetails.out_time === null && visitorDetails.visitor_acknowledge === "true" && visitorDetails.acknowledged === false && visitorDetails.department_heads?.map(String).includes(loginId) && (
                <button
                  onClick={() => {
                    setAcknowledgementModal(true);
                  }}
                  style={{ display: "flex", alignItems: "center", backgroundColor: "#f5f5f5", border: "1px solid #ddd", padding: "8px 12px", borderRadius: "12px", cursor: "pointer", fontSize: "13.5px", fontWeight: "500" }}
                >
                  <FaRegCommentDots style={{ marginRight: "5px" }} /> Acknowledgement
                </button>
              )}
            </div>
          </div>

          {/* Gate-in, Duration, and Gate-out Section */}
          {visitorDetails.in_time != null && visitorDetails.in_time !== "" && (
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px dotted #ddd",
                padding: "10px",
                borderRadius: "20px",
                position: "relative",
              }}
            >
              {/* Gate In */}
              <div
                style={{
                  border: "dashed 2px black",
                  backgroundColor: "#fff",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                Gate in : <span style={{ fontWeight: "bold", fontSize: "13px", marginLeft: "5px" }}>{visitorDetails.in_time ?? ""}</span>
              </div>

              {/* Dashed Connecting Line */}
              <div
                style={{
                  flexGrow: 1,
                  height: "2px",
                  borderTop: "2px dashed black",
                  margin: "0 10px",
                  position: "relative",
                  top: "0px",
                  zIndex: 1,
                }}
              ></div>

              {/* Time Duration */}
              <div
                style={{
                  backgroundColor: "#f0fff0",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #a3d9a5",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                <img src={clck} alt="" /> {visitorDetails.duration ?? "00:00:00"}
                hrs
              </div>

              {/* Dashed Connecting Line */}
              <div
                style={{
                  flexGrow: 1,
                  height: "2px",
                  borderTop: "2px dashed black",
                  margin: "0 10px",
                  position: "relative",
                  top: "0px",
                  zIndex: 1,
                }}
              ></div>

              {/* Gate Out */}
              {visitorDetails.gate_in === false && visitorDetails.gate_out === true && (
                <button
                  style={{
                    border: "dashed 2px black",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    padding: "8px 20px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 2,
                  }}
                  onClick={() => setShowGateOutDetails(true)}
                >
                  <img src={gate} alt="" /> Gate out
                </button>
              )}
              {visitorDetails.out_time && (
                <button
                  style={{
                    border: "dashed 2px black",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    padding: "8px 20px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  {visitorDetails.out_time ?? ""}
                </button>
              )}
            </div>
          )}
        </div>
        <div className="d-flex">
          <div className="visitor-details-card mt-2">
            <div className="field-title" style={{ padding: "14px", backgroundColor: "#fff", borderRadius: "8px" /* width: "700px", height: "889px" */ }}>
              <div className="heading-title mb-2">Visitor Details</div>
              <div className="style-justify-start py-2">
                <img src={mail} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(visitorDetails.email)}</span>
              </div>
              <div className="style-justify-start py-2">
                <img src={mobile} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(visitorDetails.mobile_number)}</span>
              </div>
              <div className="style-justify-start py-2">
                <img src={limited} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(visitorDetails.organization)}</span>
              </div>
              <div className="style-justify-start py-2">
                <img src={visitorDetails.meeting_type === "Schedule" ? clock : direct} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(visitorDetails.meeting_type)} </span>
              </div>
              {visitorDetails.schedule_time !== null && visitorDetails.schedule_time !== "" && (
                <div className="style-justify-start py-2">
                  <img src={date} alt="" /> <span style={{ paddingLeft: "8px" }}>{visitorDetails.schedule_status === "datemodi" ? `Date Modified (${visitorDetails.schedule_time})` : ` ${visitorDetails.schedule_time ?? ""}`} </span>
                </div>
              )}
              <div className="style-justify-start py-2">
                <img src={location} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(visitorDetails.location)}</span>
              </div>
              {visitorDetails.expiry_date != null && visitorDetails.expiry_date !== "" && (
                <div>
                  <div className="heading-title mt-3 mb-2">Expiry Details</div>
                  <span style={{ fontSize: "13px" }}>
                    {visitorDetails.expiry_date ?? "---"} {(visitorDetails.expiry_date && calculateDays(visitorDetails.expiry_date)) ?? 0} days
                  </span>
                </div>
              )}
              <div className="heading-title mt-3 mb-2">Proof Details</div>
              <p>
                <img src={proofphn} alt="" /> <span className="vehicle-value">{getSafeValue(visitorDetails.proof_value)}</span>{" "}
                {visitorDetails.proof_name != null && visitorDetails.proof_name != "" && (
                  <>
                    {" "}
                    <span className="dot-span mx-3"></span> <span style={{ backgroundColor: "#F1F2F4", color: "black", padding: "5px 10px", borderRadius: "8px", border: "none", fontSize: "12px" }}>{visitorDetails.proof_name}</span>
                  </>
                )}
              </p>
              <p fontFamily="Epilogue,sans-serif" style={{ color: "#a0a0a0" }}>
                Attachments:{visitorDetails?.proof_attachment?.length}
              </p>
              <div style={{ /* padding: "8px", */ display: "flex", flexDirection: "column", gap: "10px" }}>
                {visitorDetails?.proof_attachment?.map((attachment, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      background: "#F7F8F9",
                      borderRadius: "10px",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      width: "300px",
                    }}
                  >
                    <img src={attachment.file_path ?? ""} alt="Aadhaar" style={{ width: "40px", height: "40px", borderRadius: "12px" }} />
                    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, fontSize: "14px", justifyContent: "space-between  " }}>
                      <span style={{ fontWeight: "bold", color: "#1D2939" }}>{attachment.file_name ?? ""}</span>
                      <span style={{ fontSize: "12px", color: "#98A2B3" }}>{attachment.file_size ?? ""}</span>
                    </div>
                    <a href={attachment.file_path ?? ""} target="_blank" rel="noopener noreferrer" style={{ color: "#027A48", fontWeight: "bold", textDecoration: "none" }}>
                      View
                    </a>
                  </div>
                ))}
              </div>
              <div className="heading-title mt-2 mb-2">Gate & Vehicle Details</div>
              <p>
                <img src={gatedetail} alt="" /> <span className="vehicle-value">{getSafeValue(visitorDetails.gate)}</span>{" "}
              </p>
              <p>
                <img src={vechiles} alt="" /> <span className="vehicle-value">{getSafeValue(visitorDetails.vehicle_number)}</span> <span className="dot-span mx-2"></span> <span style={{ backgroundColor: "#F1F2F4", color: "black", padding: "5px 10px", borderRadius: "8px", border: "none", fontSize: "12px" }}>{visitorDetails.vehicle_type}</span>{" "}
              </p>

              <span>
                {" "}
                <div className="heading-title mt-4 mb-2">Acknowledgement</div>
              </span>
              <span style={{ fontSize: "13px" }}>{visitorDetails.acknowledge_comment ?? "---"}</span>
            </div>
          </div>
          <div className="other-details-card px-3">
            <div className="style-justify-between">
              <div className="mt-2" style={{ display: "flex", gap: "8px" }}>
                <div
                  onClick={() => setSelectedVisitHistory("Visitor")}
                  className="tab-btn px-3"
                  style={{
                    background: selectedVisitHistory === "Visitor" ? "#2C8C53" : "#FFFFFF",
                    color: selectedVisitHistory === "Visitor" ? "#FFFFFF" : "#172B4D",
                  }}
                >
                  <img src={selectedVisitHistory === "Visitor" ? visit_active : visit_inactive} alt="" /> Visitor details
                </div>
                <div
                  onClick={() => setSelectedVisitHistory("History")}
                  className="tab-btn px-3"
                  style={{
                    background: selectedVisitHistory === "History" ? "#2C8C53" : "#FFFFFF",
                    color: selectedVisitHistory === "History" ? "#FFFFFF" : "#172B4D",
                  }}
                >
                  <img src={selectedVisitHistory === "History" ? history_active : history_inactive} alt="" /> History
                </div>
              </div>
              {visitorDetails.expiry_update === true && (
                <div className="style-justify-start">
                  <div className="gate-title" style={{ width: "120px" }}>
                    Expiry date:{" "}
                  </div>
                  <div>
                    <input
                      type="date"
                      placeholder="Enter here"
                      className="input-field w-100"
                      value={expiryDate}
                      min={new Date().toISOString().split("T")[0]}
                      onChange={(event) => {
                        setExpiryDate(event.target.value);
                        updateExpiry(event.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            {selectedVisitHistory === "Visitor" && (
              <div>
                <div className="d-flex" style={{ gap: "10px" }}>
                  <div className="mt-2 other-details-inner-card">
                    <div
                      style={{
                        height: "280px",
                        borderRadius: "10px",
                        padding: "16px",
                        fontFamily: "Inter, sans-serif",
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div className="heading-title mb-2">Visit details</div>

                      {/* Business Meeting Tag */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#DBFFEA",
                          padding: "6px 10px",
                          borderRadius: "12px",
                          width: "fit-content",
                        }}
                      >
                        <img src={business} alt="Flag" style={{ marginRight: "6px" }} /> <span className="visit-purpose">{getSafeValue(visitorDetails.visit_purpose)}</span>
                      </div>

                      {/* Meeting Person Title */}
                      <div className="meeting-person mt-3 mb-2">Meeting person</div>

                      {/* Profile Section (VERTICAL ALIGNMENT) */}
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "8px" }}>
                        <img
                          src={visitorDetails.meeting_person_profile != null ? visitorDetails.meeting_person_profile : customerIcon}
                          alt="Emilia Jackson"
                          style={{
                            borderRadius: "50%",
                            width: "36px",
                            height: "36px",
                          }}
                        />
                        <div className="meeting-person-value">
                          {getSafeValue(visitorDetails.meeting_person)} {getSafeValue(visitorDetails.meeting_person_name)}
                        </div>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "12px",
                            color: "#64748B",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img src={production} alt="" style={{ width: "14px", height: "14px" }} /> {getSafeValue(visitorDetails.department)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 other-details-inner-card">
                    <div
                      style={{
                        height: "280px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "10px",
                        padding: "16px",
                        fontFamily: "Arial, sans-serif",
                        backgroundColor: "#fff",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div className="heading-title mb-2">QR code</div>
                      {/* <img
src={qr}
alt="QR Code"
style={{ marginBottom: "10px", borderRadius: "5px" }}
/> */}
                      <div ref={printRef} style={{ textAlign: "center" }}>
                        <QRCodeSVG value={visitorDetails.transaction_id ?? ""} size={160} bgColor="#ffffff" fgColor="#000000" level="H" includeMargin={true} />
                      </div>
                      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        <button onClick={downloadQR} className="download-btn px-3">
                          <img src={download} alt="" /> Download
                        </button>
                        <button onClick={handlePrint} className="download-btn px-3">
                          <img src={print} alt="" /> Print
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 other-details-inner-card">
                    <div
                      style={{
                        height: "280px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "16px",
                        padding: "16px",
                        fontFamily: "Arial, sans-serif",
                        backgroundColor: "#fff",
                      }}
                    >
                      <div className="heading-title mb-2">Check list</div>
                      <div style={{ height: "200px", overflowY: "scroll" }}>
                        {visitorDetails?.checklist?.map((check, index) => {
                          return (
                            <div
                              style={{
                                backgroundColor: check.status === "false" ? "#ffeeee" : "#DAFFE9",
                                padding: "10px",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              {check.status === "true" && <FaCheckCircle style={{ color: "green" }} />}
                              {check.status === "false" && <FaTimesCircle style={{ color: "red" }} />}
                              <span className="visit-purpose">
                                {check.checkname ?? ""} {check.creteria === "Range" ? check.value : ""}{" "}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "8px" /* marginLeft:"10px",maxWidth:"75%",maxHeight:"fit-content" */ }}>
                  {/* Box 1 */}

                  {/* Box 2 */}

                  {/* Box 3 */}

                  {/* table data */}
                  <div
                    style={{
                      background: "#FFFFFF",
                      padding: "20px",
                      borderRadius: "10px",
                      flexBasis: "90%",
                    }}
                  >
                    {/* Tabs */}
                    <div style={{ display: "flex", marginBottom: "15px", gap: "8px" }}>
                      <div
                        onClick={() => setActiveTab("items")}
                        className="tab-btn px-3"
                        style={{
                          background: activeTab === "items" ? "#D6FFE6" : "#F8F8F8",
                        }}
                      >
                        Items <span className="tab-count">{visitorDetails?.items?.length ?? 0}</span>
                      </div>
                      <div
                        onClick={() => setActiveTab("guests")}
                        className="tab-btn px-3"
                        style={{
                          background: activeTab === "guests" ? "#D6FFE6" : "#F8F8F8",
                        }}
                      >
                        Guests <span className="tab-count">{visitorDetails?.guests?.length ?? 0}</span>
                      </div>
                    </div>

                    {/* Dynamic Content: Show Items or Guests Table */}
                    {activeTab === "items" ? (
                      <table
                        className="guest-table-border"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          maxHeight: "fit-content",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              background: "#F8F9F9",
                              textAlign: "left",
                            }}
                          >
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={itemname} alt="" /> <span style={{ paddingLeft: "8px" }}>Item Name</span>
                            </th>

                            <th
                              className="guest-table-header"
                              style={{
                                padding: "10px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                <img src={Quantity} alt="" style={{ width: "16px", height: "16px" }} />
                                Quantity
                              </span>
                            </th>
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={Description} alt="" /> Description
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {visitorDetails?.items?.map((item, index) => (
                            <tr key={"itemtable" + index} className="guest-table-border">
                              <td className="guest-table-border guest-table-row-1" style={{ padding: "10px" }}>
                                {item.item_name}
                              </td>
                              <td className="guest-table-border guest-table-row-1" style={{ padding: "10px" }}>
                                {item.quantity}
                              </td>
                              <td className="guest-table-border guest-table-row-1" style={{ padding: "10px" }}>
                                {item.description}
                                {/* {index === 1 && (
                <span style={{ color: "green", cursor: "pointer" }}>
                  ...more
                </span>
              )} */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <table
                        className="guest-table-border"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead>
                          <tr style={{ background: "#F8F9F9", textAlign: "left" }}>
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={name} alt="" /> <span style={{ paddingLeft: "8px" }}>Name</span>
                            </th>
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={mnumber} alt="" /> <span style={{ paddingLeft: "8px" }}>Mobile Number</span>
                            </th>
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={age} alt="" /> <span style={{ paddingLeft: "8px" }}>Age</span>
                            </th>
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={relation} alt="" /> <span style={{ paddingLeft: "8px" }}>Relation Type</span>
                            </th>
                            <th className="guest-table-header" style={{ padding: "10px" }}>
                              <img src={proof} alt="" /> <span style={{ paddingLeft: "8px" }}>Proof</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {visitorDetails?.guests?.map((guest, index) => (
                            <tr key={"guest" + index} className="guest-table-border">
                              <td className="guest-table-border" style={{ padding: "12px", fontSize: "14px", display: "flex", alignItems: "center" }}>
                                <img src={guest.image} alt={guest.name} style={{ width: "35px", height: "35px", borderRadius: "50%", marginRight: "10px" }} />
                                <span className="guest-table-row-1">{guest.name} </span>
                              </td>
                              <td className="guest-table-border" style={{ padding: "12px", fontSize: "14px" }}>
                                <span className="guest-table-row-1">{guest.mobile_no ?? "---"}</span>
                              </td>
                              <td className="guest-table-border" style={{ padding: "12px", fontSize: "14px" }}>
                                <span className="guest-table-row-2">{guest.age ?? ""}</span>
                              </td>
                              <td className="guest-table-border" style={{ padding: "12px", fontSize: "14px" }}>
                                <span className="guest-table-row-2">{guest.type}</span>
                              </td>
                              <td className="guest-table-border" style={{ padding: "12px", fontSize: "14px" }}>
                                <span className="guest-table-row-2">{guest.proof_value}</span> &nbsp;
                                <button
                                  className="guest-table-row-1"
                                  style={{
                                    backgroundColor: "#F1F2F4",
                                    color: "black",
                                    padding: "5px 10px",
                                    borderRadius: "8px",
                                    border: "none",

                                    fontSize: "12px",
                                  }}
                                >
                                  {guest.proof_name}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            )}

            {selectedVisitHistory === "History" && (
              <div className="mt-2 other-details-card history-card">
                <div className="heading-title mb-2 style">History : {visitorHistory.length}</div>
                {visitorHistory.map((history, index) => (
                  <Row key={"checklist" + index} className="style-justify-start-start align-items-stretch">
                    <Col sm={1} className="dotted-container">
                      <div className="history-icon">
                        <HistoryIcon status={history.status} />
                      </div>

                      {index !== visitorHistory.length - 1 && <div class="vertical-line"></div>}
                    </Col>
                    <Col sm={11}>
                      <div className="mb-3">
                        <div className="heading-title">{history.status}</div>
                        <div className="vehicle-value">{history.comment ?? ""}</div>
                        {history.user && (
                          <div>
                            <span className="history-updated-by">Updated by</span> <span className="field-title">{history.user ?? ""}</span>
                          </div>
                        )}
                        <div className="meeting-person">{history.time}</div>
                      </div>
                    </Col>
                  </Row>
                ))}
              </div>
            )}
          </div>
        </div>
        <div style={{ /* padding: "20px", */ backgroundColor: "#f5f5f5" }}></div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}

export default VisitorView;
